import React, { useEffect } from 'react';
import PredictionScore, { AppProvider } from '@/pages/prediction-score';
import PredictScoreFeedback from '@/pages/predict-score-feedback';
import PracticeSetting from '@/pages/practice-setting';
import ExamPointDetail from '@/pages/exam-point-detail';
import CommonAnalysis from '@/pages/common-analysis';
import { IMicroAppProps, INoticeData } from '@/types';
import globalStore from '@/store/global';

const MicroComponents = ({ microAppType, onReceiveMessageFromMicroApp, registryNoticeMicroAppFn }: IMicroAppProps) => {
    useEffect(() => {
        // 父应用接受消息
        if (onReceiveMessageFromMicroApp) {
            globalStore.subscribe('main-app', onReceiveMessageFromMicroApp);
            globalStore.publish('main-app', { type: 'success', content: '通信已建立!' });
        }

        /* 父应用传递消息 */
        registryNoticeMicroAppFn!(({ type, params = {} }: INoticeData) => {
            switch (microAppType) {
                case 'PredictionScore':
                    globalStore.publish('PredictionScore', { type, params });
                    break;
                case 'ExamPointDetail':
                    globalStore.publish('ExamPointDetail', { type, params });
                    break;
                case 'CommonAnalysis':
                    globalStore.publish('CommonAnalysis', { type, params });
                    break;
                case 'PracticeSetting':
                    globalStore.publish('PracticeSetting', { type, params });
                    break;
                default:
                    break;
            }
        });

        return () => {
            globalStore.unsubscribe('main-app');
        };
    }, []);

    switch (microAppType) {
        case 'PredictionScore':
            return (
                <AppProvider>
                    <PracticeSetting />
                    <PredictScoreFeedback />
                    <PredictionScore />
                </AppProvider>
            );
        case 'ExamPointDetail':
            return <ExamPointDetail />;
        case 'CommonAnalysis':
            return <CommonAnalysis />;
        case 'PracticeSetting':
            return <PracticeSetting />;
        default:
            return null;
    }
};

export default MicroComponents;
